module.exports = __webpack_public_path__ + "static/media/isOver.7b9245ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/theme/components/images/isOver.png
// module id = 981
// module chunks = 0